"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherError = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var CompactContentError_1 = require("./CompactContentError");
var ErrorContainer_1 = require("./ErrorContainer");
exports.OtherError = function (_a) {
    var fullContent = _a.fullContent;
    return (react_1.default.createElement(ErrorContainer_1.ErrorContainer, null, fullContent ? (react_1.default.createElement("div", { className: "info-label-icon gd-icon-warning" },
        react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "h2" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "visualization.error.headline", tagName: "span" })),
        react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "p" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "visualization.error.text", tagName: "span" })))) : (react_1.default.createElement(CompactContentError_1.CompactContentError, { className: "gd-icon-warning", headline: "visualization.error.headline", text: "visualization.error.text" }))));
};
//# sourceMappingURL=OtherError.js.map